const ARRAY_FILTER_KEYS = ['statuses', 'priorities', 'sources', 'flag_types'];
const SINGLE_FILTER_KEYS = [
  'has_flags',
  'payment_method',
  'payment_status',
  'financial_status',
  'date_range',
  'start_date',
  'end_date'
];
const MANAGED_QUERY_KEYS = [
  'search',
  ...ARRAY_FILTER_KEYS,
  ...SINGLE_FILTER_KEYS,
  'sort',
  // Retained for backwards compatibility with existing Orders URLs.
  'source'
];

export const DEFAULT_ORDER_START_DATE = '2026-08-01';

const readArray = (searchParams, key) => (
  searchParams
    .getAll(key)
    .flatMap(value => value.split(','))
    .map(value => value.trim())
    .filter(Boolean)
);

export const createDefaultOrderFilters = (fixedSource = null) => ({
  search: '',
  statuses: [],
  priorities: [],
  sources: fixedSource ? [fixedSource] : [],
  flag_types: [],
  has_flags: '',
  payment_method: '',
  payment_status: '',
  financial_status: '',
  date_range: 'custom',
  start_date: DEFAULT_ORDER_START_DATE,
  end_date: null,
  sort: 'created_at_desc'
});

export const readOrderFiltersFromQuery = (searchParams, fixedSource = null) => {
  const filters = createDefaultOrderFilters(fixedSource);

  filters.search = searchParams.get('search') || '';
  ARRAY_FILTER_KEYS.forEach(key => {
    filters[key] = readArray(searchParams, key);
  });
  SINGLE_FILTER_KEYS.forEach(key => {
    filters[key] = searchParams.get(key) || filters[key];
  });
  filters.sort = searchParams.get('sort') || filters.sort;

  if (fixedSource) {
    filters.sources = [fixedSource];
  } else if (filters.sources.length === 0 && searchParams.get('source')) {
    filters.sources = [searchParams.get('source')];
  }

  return filters;
};

export const writeOrderFiltersToQuery = (
  currentSearchParams,
  filters,
  fixedSource = null
) => {
  const nextSearchParams = new URLSearchParams(currentSearchParams);
  MANAGED_QUERY_KEYS.forEach(key => nextSearchParams.delete(key));

  const search = filters.search?.trim();
  if (search) {
    nextSearchParams.set('search', search);
  }

  ARRAY_FILTER_KEYS.forEach(key => {
    const values = key === 'sources' && fixedSource
      ? []
      : filters[key];
    if (values?.length) {
      nextSearchParams.set(key, values.join(','));
    }
  });

  SINGLE_FILTER_KEYS.forEach(key => {
    if (filters[key]) {
      nextSearchParams.set(key, filters[key]);
    }
  });

  if (filters.sort && filters.sort !== 'created_at_desc') {
    nextSearchParams.set('sort', filters.sort);
  }

  return nextSearchParams;
};
